// extracted by mini-css-extract-plugin
module.exports = {"searchRow":"FaqResultsContainer_searchRow__KamVK","contentColumn":"FaqResultsContainer_contentColumn__5nBQt"};